import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=6c2684c6&scoped=true&"
import script from "./detail.vue?vue&type=script&lang=js&"
export * from "./detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c2684c6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c2684c6')) {
      api.createRecord('6c2684c6', component.options)
    } else {
      api.reload('6c2684c6', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=6c2684c6&scoped=true&", function () {
      api.rerender('6c2684c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/master_hattyu_company/detail.vue"
export default component.exports